
export const status = {
  'status.complete': 'Complet',
  'status.incomplete': 'Incomplet',
  'status.pending': 'En Attente',
  'status.rejected': 'Rejeté',
  'status.approved': 'Approuvé',
  'status.review': 'En Révision',
  'status.draft': 'Brouillon',
  'status.submitted': 'Soumis',
  'status.processing': 'En Traitement',
  'status.error': 'Erreur',
  'status.success': 'Succès',
  'status.warning': 'Avertissement',
  'status.info': 'Information',
  'status.active': 'Actif',
  'status.inactive': 'Inactif',
  'status.expired': 'Expiré',
  'status.closed': 'Fermé',
  'status.permanent': 'Permanent',
  'status.comingSoon': 'Bientôt Disponible',
  'status.disabled': 'Désactivé',
  'status.enabled': 'Activé',
  'status.locked': 'Verrouillé',
  'status.unlocked': 'Déverrouillé',
  'status.blocked': 'Bloqué',
  'status.unblocked': 'Débloqué',
  'status.verified': 'Vérifié',
  'status.unverified': 'Non Vérifié',
  'status.suspended': 'Suspendu',
  'status.unsuspended': 'Réactivé',
  'status.deleted': 'Supprimé',
  'status.restored': 'Restauré',
  'status.archived': 'Archivé',
  'status.unarchived': 'Désarchivé',
  'status.published': 'Publié',
  'status.unpublished': 'Non Publié',
  'status.inProgress': 'En Cours',
  'status.inReview': 'En Révision',
  'status.needsUpdate': 'Nécessite Mise à Jour',
  'status.profileComplete': 'Profil Complet',
  'status.subsidyInProgress': 'Subvention En Cours',
  'status.inPreparation': 'En Préparation',
  'status.readyToSubmit': 'Prêt à Soumettre'
} as const;
